/** Take in desired layout and filter out disabled or invisible items */
export function filterNonSelectableOptions(
  menuOptionsLayout = [],
  menuOptions = {}
) {
  return menuOptionsLayout.map(row => {
    return row.filter(optionKey => {
      const optionModel = menuOptions[optionKey];

      if (
        typeof optionModel.isDisabled === "function" &&
        optionModel.isDisabled()
      ) {
        return false;
      }

      if (
        typeof optionModel.isVisible === "function" &&
        !optionModel.isVisible()
      ) {
        return false;
      }

      return true;
    });
  });
}



// WEBPACK FOOTER //
// ./src/menu-engine/filterNonSelectableOptionItems.js